// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2V6qv","col":"Table_col__f42r8","fulfillmentStatus":"Table_fulfillmentStatus__2rmMT","emailCol":"Table_emailCol__IWIx3"};